// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Hn1cj","logo":"Header_logo__nZ7K6"};